















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import _ from 'lodash';

import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { MapUtil } from '@/util/MapUtil';

import { gmapApi } from 'vue2-google-maps'

const DEFAULT_LATITUDE:number = -33.865143;
const DEFAULT_LONGITUDE:number = 151.209900;

@Component({
  components:{
    VueError,
    Success,
    SectionHeader,
  }
})
export default class UpdateLocation extends Vue {

  error = '';
  success = '';
  localAddress = 'Please wait...';

  @Prop({ default: '',  type: String}) deviceId!:string;
  @Prop({ default: Number.MAX_VALUE,  type: Number}) latitude!:number;
  @Prop({ default: Number.MAX_VALUE,  type: Number}) longitude!:number;
  
  markerPos = {lat:DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE};

  gmapOptions:object = {
    streetViewControl: false,
    mapTypeControl: false,
    zoom: 10
  };

  geoCodeTimeout = -1;
  markerDraggedTimeout = -1;
  httpBusy:boolean = false;

  private coreClient:CoreClient = curCoreClient;
  private mapUtil:MapUtil = new MapUtil();

  async mounted() {

    this.success = '';
    this.error = '';

    // we initalise the marker to the initial position if any
    if(this.latitude !== Number.MAX_VALUE && this.longitude !== Number.MAX_VALUE)
      return this.newLocation(this.latitude, this.longitude);
    
    // otherwise we try and get the local position
    const pos = await this.mapUtil.getLocalPosition();
    
    if(pos.lat === undefined || pos.long === undefined)
      return;

    // then we update the local position
    this.newLocation(pos.lat, pos.long);
  }

  markerDragged(evt:any) {

    if(this.markerDraggedTimeout)
      clearTimeout(this.markerDraggedTimeout);
    
    this.markerDraggedTimeout = window.setTimeout(() => {

      const localPos = JSON.parse(JSON.stringify(evt.latLng));

      // we round up to the 7th dec position
      localPos.lat = Math.round(localPos.lat*1e7)/1e7;
      localPos.lng = Math.round(localPos.lng*1e7)/1e7;

      // we update locally
      this.newLocation(localPos.lat, localPos.lng);

    }, 300);

    return true;
  }

  manualPosChange(lat:number|string, long:number|string) {

    lat = parseFloat(lat as string);
    long = parseFloat(long as string);

    this.newLocation(lat, long);
  }

  async newLocation(lat:number, long:number) {

     // we update the marker
    this.markerPos = {lat:lat, lng:long};

    if(this.geoCodeTimeout)
      clearTimeout(this.geoCodeTimeout);
    
    this.geoCodeTimeout = window.setTimeout(async () => {

      this.localAddress = 'Please wait...';

      // we try and get an address
      const geocodeReply = await this.mapUtil.geocode(this.google, lat, long);

      if(!geocodeReply.address)
        return;
      
      // we got an address
      this.localAddress = geocodeReply.address;
      
    }, 300);

    
  }

  canUpdate():boolean {
    return (this.latitude !== this.markerPos.lat || this.longitude !== this.markerPos.lng) && !this.httpBusy;
  }

  canCancel():boolean {
    return !this.httpBusy;
  }

  cancel() {
    this.$emit('close');
  }

  async updateLocation() {

    this.httpBusy = true;

    // nothing here yet
    const reply = await this.coreClient.updateDeviceLocation({deviceId:this.deviceId, latitude: this.markerPos.lat, longitude:this.markerPos.lng});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to update device location: ${reply.errorMsg}`;
    
    this.success = `Location for device ${this.deviceId} updated successfully`;

    setTimeout( () => { this.$emit('close'); }, 1500)
  }

  get google() {
    return gmapApi();
  }
  

}

